export default __webpack_public_path__ + "static/media/Teal_Check_Mark.ae2bb591.gif";